import React from "react";
import projects from "../data/projectsData";
import "../Assets/WebsiteCss/ServicePlanning.css";
import housemodel from "../Assets/images/housemodel.jpg";
import floor_plan from "../Assets/images/floor_plan.jpg";
import {
  FaCube,
  FaRulerCombined,
  FaPencilRuler,
  FaCheckCircle,
  FaHome,
} from "react-icons/fa";
import { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../BaseURL";
import ProjectsPreview from "../Components/ProjectsPreview";
// import "../Assets/WebsiteCss/Project.css";

const ServicePlanning = () => {
  const features = [
    {
      icon: <FaCube />,
      title: "3D Visualization",
      description:
        "Photorealistic 3D renders that bring your vision to life before construction begins",
    },
    {
      icon: <FaRulerCombined />,
      title: "Precise Measurements",
      description:
        "Detailed floor plans with accurate dimensions and spatial planning",
    },
    {
      icon: <FaPencilRuler />,
      title: "Custom Design",
      description:
        "Tailored architectural solutions that match your lifestyle and budget",
    },
  ];

  const process = [
    {
      number: "01",
      title: "Initial Consultation",
      description:
        "We discuss your requirements, budget, and vision for your dream space",
    },
    {
      number: "02",
      title: "Site Analysis",
      description:
        "Comprehensive evaluation of your plot including dimensions and constraints",
    },
    {
      number: "03",
      title: "Concept Development",
      description:
        "Creating preliminary sketches and layout options for your review",
    },
    {
      number: "04",
      title: "3D Modeling",
      description:
        "Developing detailed 3D models and photorealistic visualizations",
    },
    {
      number: "05",
      title: "Final Documentation",
      description:
        "Complete architectural drawings ready for approval and construction",
    },
  ];
  const [projects, setProjects] = useState([]);
  const [categoryMap, setCategoryMap] = useState({});

  useEffect(() => {
    const loadData = async () => {
      const projectRes = await axios.get(`${BASE_URL}/api/projects`);
      const categoryRes = await axios.get(
        `${BASE_URL}/api/category/get-category`,
      );
      const map = {};
      categoryRes.data.data.forEach((c) => {
        map[c._id] = c.categoryName;
      });

      const allProjects = projectRes.data.data;

      //  Latest 3 projects
      setProjects(allProjects.slice(-3).reverse());
      setCategoryMap(map);
    };

    loadData();
  }, []);

  return (
    <div className="sp-page">
      {/* HERO SECTION */}
      <section className="sp-hero">
        <div className="sp-hero-overlay" />
        <div className="sp-hero-content">
          <div className="sp-hero-badge">
            <FaHome /> Our Services
          </div>
          <h1 className="sp-hero-title">
            Building Planning
            <span className="sp-highlight">&amp; 3D Design</span>
          </h1>
          <p className="sp-hero-subtitle">
            Transform your vision into detailed architectural plans with our
            expert design team. From concept to construction-ready drawings, we
            bring precision and creativity to every project.
          </p>
          <div className="sp-hero-stats">
            <div className="sp-stat-item">
              <span className="sp-stat-number">500+</span>
              <span className="sp-stat-label">Plans Designed</span>
            </div>
            <div className="sp-stat-divider" />
            <div className="sp-stat-item">
              <span className="sp-stat-number">100%</span>
              <span className="sp-stat-label">Client Satisfaction</span>
            </div>
            <div className="sp-stat-divider" />
            <div className="sp-stat-item">
              <span className="sp-stat-number">15+</span>
              <span className="sp-stat-label">Years Experience</span>
            </div>
          </div>
        </div>
      </section>

      {/* SHOWCASE SECTION */}
      <section className="sp-showcase-section">
        <div className="sp-showcase-grid">
          <div className="sp-showcase-item">
            <div className="sp-showcase-image-wrapper">
              <img
                src={housemodel}
                alt="3D House Model Visualization"
                className="sp-showcase-image"
              />
              <div className="sp-image-badge">3D Visualization</div>
            </div>
            <div className="sp-showcase-content">
              <h3>Photorealistic 3D Models</h3>
              <p>
                Experience your future home before construction starts. Our
                advanced 3D modeling technology creates stunning visualizations
                that help you make informed decisions about materials, colors,
                and layouts.
              </p>
              <ul className="sp-showcase-features">
                <li>
                  <FaCheckCircle /> Exterior and interior renderings
                </li>
                <li>
                  <FaCheckCircle /> Multiple viewing angles
                </li>
                <li>
                  <FaCheckCircle /> Virtual walkthroughs
                </li>
                <li>
                  <FaCheckCircle /> Material and lighting simulations
                </li>
              </ul>
            </div>
          </div>

          <div className="sp-showcase-item sp-reverse">
            <div className="sp-showcase-image-wrapper">
              <img
                src={floor_plan}
                alt="Detailed Architectural Floor Plan"
                className="sp-showcase-image"
              />
              <div className="sp-image-badge">Floor Planning</div>
            </div>
            <div className="sp-showcase-content">
              <h3>Detailed Floor Plans</h3>
              <p>
                Precision-engineered floor plans that maximize space efficiency
                and functionality. Every measurement is carefully calculated to
                ensure optimal use of your property.
              </p>
              <ul className="sp-showcase-features">
                <li>
                  <FaCheckCircle /> Accurate dimensions and measurements
                </li>
                <li>
                  <FaCheckCircle /> Furniture layout suggestions
                </li>
                <li>
                  <FaCheckCircle /> Electrical and plumbing layouts
                </li>
                <li>
                  <FaCheckCircle /> Structural details and specifications
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* FEATURES GRID */}
      <section className="sp-features-section">
        <div className="sp-section-header">
          <h2 className="sp-section-title">Why Choose Our Planning Services</h2>
          {/* <p className="sp-section-subtitle">
            Comprehensive design solutions backed by years of expertise
          </p> */}
        </div>

        <div className="sp-features-grid">
          {features.map((feature, index) => (
            <div key={index} className="sp-feature-card">
              <div className="sp-feature-icon">{feature.icon}</div>
              <h3 className="sp-feature-title">{feature.title}</h3>
              <p className="sp-feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </section>


      <section className="sp-related-projects">
        <div className="sp-section-header">
          <h2 className="sp-section-title">Some of our recent projects</h2>
        </div>

        <div className="sp-projects-wrapper">
          <ProjectsPreview projects={projects} categoryMap={categoryMap} />
        </div>
      </section>
    </div>
  );
};

export default ServicePlanning;
